var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[(_vm.backPath !== '')?_c('a-icon',{staticClass:"back-button",attrs:{"type":"left-circle"},on:{"click":_vm.returnHome}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }